/* eslint-disable @typescript-eslint/no-non-null-assertion */
import L from 'leaflet';
import ReactDOM from 'react-dom';
import React from 'react';
import {
  ContextCircularMenu,
  ContextCircularItem,
} from './SmartMapContextMenu';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function openRadialContextMenu(
  map: L.Map,
  e: L.LeafletMouseEvent,
  items: ContextCircularItem[]
) {
  // create the container for React menu
  const container = document.createElement('div');

  // render the radial menu
  ReactDOM.render(<ContextCircularMenu items={items} />, container);

  // open popup that won't auto-close on click
  const popup = L.popup({
    className: 'smart-map-marker-menu-popup',
  })
    .setLatLng(e.latlng)
    .setContent(container)
    .openOn(map);

  // attach native click listeners for each slice
  const itemEls = popup
    .getElement()!
    .querySelectorAll<HTMLDivElement>('.context-item');

  itemEls.forEach((el, idx) => {
    el.style.cursor = 'pointer';
    el.addEventListener('click', (ev) => {
      ev.stopPropagation();
      // call the handler
      items[idx].onClick();
      // close the popup
      map.closePopup();
    });
  });
}
